export default "__VITE_ASSET__CNIQqioF__"